























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Fraction from 'fraction.js/fraction';
import appState, {Building} from "@/store/app";

@Component
export default class ProductResult extends Vue {
    private farmsCount = 3; // TBD technologies
    private harvesterCount = 3;
    @Prop({required: true}) recipeId!: number;
    @Prop({required: true}) flow!: Fraction;

    get int() { return this.flow.floor().n; }
    get frac() { return this.flow.sub(this.int).valueOf() }

    get building(): Building | undefined { return this.recipe.requiredModules.length ?
        appState.buildingByName(this.recipe.requiredModules[0].buildingName) :
        appState.buildings[appState.recipes[this.recipeId].building];
    }

    get buildingImage() { return (bld: Building): string => '/static/buildings/' + bld.constructionBarIcon.replace(/-/g, '_') + '.png'; }
    get backgroundImage() {
        return this.building!.constructionBarIcon ?
            `url( ${this.buildingImage(this.building!)} )` :
            'none';
    }
    get recipe() { return appState.recipes[this.recipeId]; }

    get recipes() { return appState.recipes; }
    get products() { return appState.products; }
    get buildings() { return appState.buildings; }


}
